export default __webpack_public_path__ + "static/media/Giftcard.06f3fcc9.png";